import jwtAuthAxios from "./auth/jwtAuth";

const driverServices = {};

driverServices.updateDriver = async (driver_id, params) => {
    const {data} = await jwtAuthAxios.post(`/users/${driver_id}/driver_settings`, params);
    return data;
};

export default driverServices;